var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import styles from './cookie-app.component.scss';
import { Component, h, render } from 'preact';
import CookieCategoryList from '../cookie-category-list/cookie-category-list.component';
import CookieCategoryDescriptionList from '../cookie-category-description-list/cookie-category-description-list.component';
import CookieButton from '../cookie-button/cookie-button.component';
import DataService from '../../service/data.service';
import CookieStatusService from '../../service/cookie-status.service';
import WrapperService from '../../service/wrapper.service';
import TranslateService from '../../service/translate.service';
import CookiePreview from "../cookie-preview/cookie-preview.component";
var CookieApp = /** @class */ (function (_super) {
    __extends(CookieApp, _super);
    function CookieApp() {
        var _this = _super.call(this) || this;
        _this.dataService = DataService.getInstance();
        _this.cookieStatusService = CookieStatusService.getInstance();
        _this.wrapperService = WrapperService.getInstance();
        _this.state = {
            showCategoryDescription: false,
            verified: false,
            minimized: false
        };
        _this.toggleCategoryDescription = _this.toggleCategoryDescription.bind(_this);
        _this.minimize = _this.minimize.bind(_this);
        _this.maximize = _this.maximize.bind(_this);
        _this.buttonUpdate = _this.buttonUpdate.bind(_this);
        _this.deleteCookie = _this.deleteCookie.bind(_this);
        _this.renderPreview = _this.renderPreview.bind(_this);
        // this.setState = this.setState.bind(this);
        _this.Start = _this.Start.bind(_this);
        _this.toggleCategoryDescription = _this.toggleCategoryDescription.bind(_this);
        var element = document.getElementById("cookieConsentmentDiv");
        _this.lang = element.getAttribute("data-prop-lang");
        _this.apiBaseUrl = element.getAttribute("data-prop-api-base-url");
        _this.apiKey = element.getAttribute("data-prop-api-key");
        _this.cookieKey = element.getAttribute("data-prop-cookie-key");
        _this.websiteId = parseInt(element.getAttribute("data-prop-id"));
        _this.dataProtectionSide = element.getAttribute("data-prop-protection-site");
        if (_this.lang == null) {
            _this.lang = "en";
        }
        _this.dataService.ApiBaseUrl = _this.apiBaseUrl;
        _this.dataService.ApiKey = _this.apiKey;
        _this.cookieStatusService.CookieKey = _this.cookieKey;
        _this.dataProtectionLink = _this.dataProtectionSide;
        TranslateService.setLanguage(_this.lang);
        return _this;
    }
    CookieApp.prototype.Start = function () {
        return __awaiter(this, void 0, void 0, function () {
            var verified, needed;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dataService.init(this.websiteId)];
                    case 1:
                        verified = _a.sent();
                        if (!!(typeof verified.id === 'number')) return [3 /*break*/, 2];
                        throw new Error('This Url Is not registert to use this Service');
                    case 2: return [4 /*yield*/, this.cookieStatusService.isOldData()];
                    case 3:
                        needed = _a.sent();
                        if (!!needed) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.cookieStatusService.loadOldStatus()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.wrapperService.loadScripts()];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 6: return [4 /*yield*/, this.cookieStatusService.refreshCookie()];
                    case 7:
                        _a.sent();
                        _a.label = 8;
                    case 8:
                        // this.setState({
                        //   verified: true,
                        //   minimized: !needed
                        // });
                        this.state.verified = true;
                        this.state.minimized = !needed;
                        _a.label = 9;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    //wird aktuell nicht mehr angesprochen
    CookieApp.prototype.componentWillMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var verified, needed;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.props['apiBaseUrl']) {
                            throw new Error('No API-BaseUrl found.');
                        }
                        if (!this.props['apiKey']) {
                            throw new Error('No API-Key found.');
                        }
                        if (!this.props['cookieKey']) {
                            throw new Error('No Cookie-Key found.');
                        }
                        if (!this.props['id']) {
                            throw new Error('No Website-Id found.');
                        }
                        this.dataService.ApiBaseUrl = this.props['apiBaseUrl'];
                        this.dataService.ApiKey = this.props['apiKey'];
                        this.cookieStatusService.CookieKey = this.props['cookieKey'];
                        this.dataProtectionLink = this.props['dataProtectionSite'];
                        TranslateService.setLanguage(this.props['lang'] ? this.props['lang'] : 'en');
                        return [4 /*yield*/, this.dataService.init(this.props['id'])];
                    case 1:
                        verified = _a.sent();
                        if (!!(typeof verified.id === 'number')) return [3 /*break*/, 2];
                        throw new Error('This Url Is not registert to use this Service');
                    case 2: return [4 /*yield*/, this.cookieStatusService.isOldData()];
                    case 3:
                        needed = _a.sent();
                        if (!!needed) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.cookieStatusService.loadOldStatus()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.wrapperService.loadScripts()];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 6: return [4 /*yield*/, this.cookieStatusService.refreshCookie()];
                    case 7:
                        _a.sent();
                        _a.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    CookieApp.prototype.toggleCategoryDescription = function (ev) {
        ev.preventDefault();
        this.state.showCategoryDescription = !this.state.showCategoryDescription;
        var cookieDescriptionDiv = document.getElementById("cookieShowDescriptionDiv");
        var cookieCategoryList = document.getElementById("cookieCategoryDescriptionList");
        if (cookieDescriptionDiv.classList.contains("open")) {
            cookieDescriptionDiv.classList.remove("open");
            cookieDescriptionDiv.innerHTML = TranslateService.Translate.ccs.details.more;
        }
        else {
            cookieDescriptionDiv.classList.add("open");
            cookieDescriptionDiv.innerHTML = TranslateService.Translate.ccs.details.less;
        }
        if (!cookieCategoryList.classList.contains("visible")) {
            cookieCategoryList.classList.add("visible");
        }
        else {
            cookieCategoryList.classList.remove("visible");
        }
        // this.setState({
        //   showCategoryDescription: !this.state.showCategoryDescription
        // });
    };
    // private toggleMinimized() {
    //   this.state.minimized = !this.state.minimized;
    //   // this.setState({
    //   //   minimized: !this.state.minimized
    //   // });
    // }
    CookieApp.prototype.maximize = function () {
        // if (this.state.minimized) {
        this.state.minimized = false;
        var cookieOverlay = document.getElementById("cookieOverlay");
        if (cookieOverlay != undefined) {
            if (cookieOverlay.classList.contains("cookie-overlay-minimized")) {
                cookieOverlay.classList.remove("cookie-overlay-minimized");
            }
        }
        var cookieContainer = document.getElementById("cookieContainer");
        if (cookieContainer) {
            if (cookieContainer.classList.contains("cookie-container-minimized")) {
                cookieContainer.classList.remove("cookie-container-minimized");
            }
        }
        // this.setState({
        //   minimized: false
        // });
        // }
    };
    CookieApp.prototype.minimize = function () {
        var cookieOverlay = document.getElementById("cookieOverlay");
        if (!cookieOverlay.classList.contains("cookie-overlay-minimized")) {
            cookieOverlay.classList.add("cookie-overlay-minimized");
        }
        var cookieContainer = document.getElementById("cookieContainer");
        if (!cookieContainer.classList.contains("cookie-container-minimized")) {
            cookieContainer.classList.add("cookie-container-minimized");
        }
    };
    CookieApp.prototype.buttonUpdate = function (event, info) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = info.action;
                        switch (_a) {
                            case 'acceptSelected': return [3 /*break*/, 1];
                            case 'acceptAll': return [3 /*break*/, 4];
                        }
                        return [3 /*break*/, 7];
                    case 1: return [4 /*yield*/, this.cookieStatusService.saveToCookie()];
                    case 2:
                        _b.sent();
                        return [4 /*yield*/, this.wrapperService.loadScripts()];
                    case 3:
                        _b.sent();
                        setTimeout(function () {
                            // this.setState({
                            //  minimized: true
                            // });
                            _this.state.minimized = true;
                            _this.minimize();
                        }, 10);
                        return [3 /*break*/, 8];
                    case 4: return [4 /*yield*/, this.cookieStatusService.acceptAllCookieGroups()];
                    case 5:
                        _b.sent();
                        return [4 /*yield*/, this.wrapperService.loadScripts()];
                    case 6:
                        _b.sent();
                        setTimeout(function () {
                            // this.setState({
                            //   minimized: true
                            // });
                            _this.state.minimized = true;
                            _this.minimize();
                        }, 500);
                        return [3 /*break*/, 8];
                    case 7: throw new Error('not a valid button action');
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    CookieApp.prototype.deleteCookie = function () {
        return __awaiter(this, void 0, void 0, function () {
            var name, domain, path;
            return __generator(this, function (_a) {
                name = this.cookieKey;
                domain = window.location.hostname;
                path = "/";
                this.removeCookiesFromDomain(name);
                this.renderPreview();
                return [2 /*return*/];
            });
        });
    };
    CookieApp.prototype.renderPreview = function () {
        return __awaiter(this, void 0, void 0, function () {
            var preview, nodeToAdd;
            return __generator(this, function (_a) {
                preview = new CookiePreview().render();
                if (preview != undefined) {
                    nodeToAdd = document.getElementById("cookieConsentmentDiv");
                    nodeToAdd.innerHTML = '';
                    render(preview, nodeToAdd);
                }
                return [2 /*return*/];
            });
        });
    };
    CookieApp.prototype.removeCookiesFromDomain = function (name) {
        var domain = window.location.hostname;
        var path = "/";
        document.cookie.split(';').forEach(function (el) {
            var _a = el.split('='), key = _a[0], value = _a[1];
            if (key.trim() == name) {
                document.cookie = key.trim() + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=" + path + ";";
            }
        });
    };
    CookieApp.prototype.render = function () {
        var overlayStyling = "" + styles['cookie-overlay'];
        var cookieContainerStyling = "" + styles['cookie-container'];
        if (this.state.minimized) {
            overlayStyling += " " + styles['cookie-overlay-minimized'];
            cookieContainerStyling += " " + styles['cookie-container-minimized'];
        }
        return (this.state.verified ? (h("div", { class: "" + styles['cookie-consent-manager'] },
            h("div", { class: overlayStyling, id: "cookieOverlay" }),
            h("div", { class: cookieContainerStyling, id: "cookieContainer", onClick: this.maximize },
                h("div", { class: "" + styles['cookie-scroll-container'] },
                    h("div", { class: "" + styles['cookie-heading'] },
                        h("h1", null, this.dataService.initData.languages[TranslateService.getLanguage()].title)),
                    h("div", { class: "" + styles['cookie-info'] },
                        this.dataService.initData.languages[TranslateService.getLanguage()].description,
                        this.dataProtectionLink ? (h("a", { href: this.dataProtectionLink }, TranslateService.Translate.ccs.dataProtection)) : ''),
                    h(CookieCategoryList, null),
                    h("div", { class: "" + styles['cookie-additional-infos'] },
                        h("div", { class: "" + styles['cookie-categories-description'] },
                            h("div", { id: "cookieShowDescriptionDiv", class: !this.state.showCategoryDescription ?
                                    styles['cookie-link-btn-inv'] + " " + styles['cookie-categories-description-more'] :
                                    styles['cookie-link-btn-inv'] + " " + styles['cookie-categories-description-more'] + " " + styles['open'], onClick: this.toggleCategoryDescription }, !this.state.showCategoryDescription ? TranslateService.Translate.ccs.details.more : TranslateService.Translate.ccs.details.less),
                            h(CookieCategoryDescriptionList, { categories: this.dataService.initData.cookiegroups, visible: this.state.showCategoryDescription })))),
                h("div", { class: "" + styles['cookie-action-area'] },
                    h(CookieButton, { type: "secondary", label: TranslateService.Translate.ccs.deleteCookie, info: { action: 'acceptSelected' }, buttonUpdate: this.deleteCookie }),
                    h(CookieButton, { type: "secondary", label: TranslateService.Translate.ccs.acceptSelected, info: { action: 'acceptSelected' }, buttonUpdate: this.buttonUpdate }),
                    h(CookieButton, { type: "primary", label: TranslateService.Translate.ccs.acceptAll, info: { action: 'acceptAll' }, buttonUpdate: this.buttonUpdate })),
                h("div", { class: "" + styles['cookie-container-open'] },
                    h("div", { style: "display:none;" }, "fa fingerprint"),
                    h("svg", { width: "28px", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" },
                        h("path", { d: "M256.12 245.96c-13.25 0-24 10.74-24 24 1.14 72.25-8.14 141.9-27.7 211.55-2.73 9.72 2.15 30.49 23.12 30.49 10.48 0 20.11-6.92 23.09-17.52 13.53-47.91 31.04-125.41 29.48-224.52.01-13.25-10.73-24-23.99-24zm-.86-81.73C194 164.16 151.25 211.3 152.1 265.32c.75 47.94-3.75 95.91-13.37 142.55-2.69 12.98 5.67 25.69 18.64 28.36 13.05 2.67 25.67-5.66 28.36-18.64 10.34-50.09 15.17-101.58 14.37-153.02-.41-25.95 19.92-52.49 54.45-52.34 31.31.47 57.15 25.34 57.62 55.47.77 48.05-2.81 96.33-10.61 143.55-2.17 13.06 6.69 25.42 19.76 27.58 19.97 3.33 26.81-15.1 27.58-19.77 8.28-50.03 12.06-101.21 11.27-152.11-.88-55.8-47.94-101.88-104.91-102.72zm-110.69-19.78c-10.3-8.34-25.37-6.8-33.76 3.48-25.62 31.5-39.39 71.28-38.75 112 .59 37.58-2.47 75.27-9.11 112.05-2.34 13.05 6.31 25.53 19.36 27.89 20.11 3.5 27.07-14.81 27.89-19.36 7.19-39.84 10.5-80.66 9.86-121.33-.47-29.88 9.2-57.88 28-80.97 8.35-10.28 6.79-25.39-3.49-33.76zm109.47-62.33c-15.41-.41-30.87 1.44-45.78 4.97-12.89 3.06-20.87 15.98-17.83 28.89 3.06 12.89 16 20.83 28.89 17.83 11.05-2.61 22.47-3.77 34-3.69 75.43 1.13 137.73 61.5 138.88 134.58.59 37.88-1.28 76.11-5.58 113.63-1.5 13.17 7.95 25.08 21.11 26.58 16.72 1.95 25.51-11.88 26.58-21.11a929.06 929.06 0 0 0 5.89-119.85c-1.56-98.75-85.07-180.33-186.16-181.83zm252.07 121.45c-2.86-12.92-15.51-21.2-28.61-18.27-12.94 2.86-21.12 15.66-18.26 28.61 4.71 21.41 4.91 37.41 4.7 61.6-.11 13.27 10.55 24.09 23.8 24.2h.2c13.17 0 23.89-10.61 24-23.8.18-22.18.4-44.11-5.83-72.34zm-40.12-90.72C417.29 43.46 337.6 1.29 252.81.02 183.02-.82 118.47 24.91 70.46 72.94 24.09 119.37-.9 181.04.14 246.65l-.12 21.47c-.39 13.25 10.03 24.31 23.28 24.69.23.02.48.02.72.02 12.92 0 23.59-10.3 23.97-23.3l.16-23.64c-.83-52.5 19.16-101.86 56.28-139 38.76-38.8 91.34-59.67 147.68-58.86 69.45 1.03 134.73 35.56 174.62 92.39 7.61 10.86 22.56 13.45 33.42 5.86 10.84-7.62 13.46-22.59 5.84-33.43z" })))))) : false);
    };
    return CookieApp;
}(Component));
export default CookieApp;



//////////////////
// WEBPACK FOOTER
// ./components/cookie-app/cookie-app.component.tsx
// module id = null
// module chunks = 